import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { QueryTimes } from "~/application/constants";
import { logError } from "~/presentation/shared/utils/errors";

const LOG_TAG = "Customer/CustomerDashboardBIV2Page/useDashboardQuery";

export function useDashboardQuery<TData>(
  queryKey: unknown[],
  queryFn: () => Promise<TData>,
  enabled: boolean,
  options?: Omit<UseQueryOptions<TData, Error, TData, unknown[]>, "queryKey" | "queryFn" | "enabled">
) {
  return useQuery({
    queryKey,
    queryFn,
    staleTime: QueryTimes.NORMAL,
    enabled,
    onError: (error: Error) => {
      logError({
        logTag: LOG_TAG,
        error,
        defaultErrorMessage: "Erro ao buscar dados no Dashboard",
      });
    },
    ...options,
  });
}
